'use strict'

class UserFormCtrl {

    constructor ($state, $stateParams, User, $mdToast, $http, $mdDialog, $rootScope) {

        this.$state = $state
        this._User = User
        this.buttonDisabled = false
        this.$mdToast = $mdToast
        this.$http = $http
        this.$mdDialog = $mdDialog
        this.$stateParams = $stateParams
        this.$rootScope = $rootScope
        this.roles = []

        this.formdata = {}

        if ($stateParams.id) {

            User.get({ id: $stateParams.id }, (data) => {

                angular.extend(this.formdata, data)
            })
        }

        this.fetchRoles()

        this.$http.get('/organisation/user-subscription')
            .then((response) => {
                this.maxreached = response.data.maxReached
            })

        this.$http.get('/station').then((response) => {
            this.adfs = response.data.is_adfs
        })
    }

    fetchRoles () {
        return this.$http.get('/roles').then(result => {
            const roles = this.roles = result.data.data

            if (!roles.find(role => role.id === 1)) {
                roles.unshift({ id: 1, name: 'Admin' })
            }

            return roles
        })
    }

    //this date transform the custom date to 'new Date' so it can be re-used
    makeDate (date) {
        return date ? new Date(date) : new Date()
    }

    cancel () {
        this.$state.go('user')
    }

    save ($valid, ev) {
        if (!$valid) {
            return
        }

        this.buttonDisabled = true

        let modelData = angular.copy(this.formdata)

        if (this.maxreached && !this.formdata.id) {
            this.$mdDialog.show({
                controller: 'ConfirmDialogCtrl',
                templateUrl: 'maxUsers.ngTemplate',
                parent: angular.element(document.querySelector('#popupContainer')),
                targetEvent: ev,
                clickOutsideToClose: true
            })
            this.buttonDisabled = false
            return
        }

        this._User.save(modelData, (data) => {

            if (this.formdata.id) {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.saved?object=user&title=' + this.formdata.firstname + '%20' + this.formdata.lastname,
                    hideDelay: 6000,
                    position: ('top right')
                })

            } else {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.create?object=user&title=' + this.formdata.firstname + '%20' + this.formdata.lastname,
                    hideDelay: 6000,
                    position: ('top right')
                })
            }

            if (this.$stateParams.fromOtherSource) {
                //Broadcast user (back to item view)
                this.$rootScope.$broadcast('made_new_user', data)

                //Return to previous view
                this.$state.go('^')
            } else {
                this.$state.go('user.update', { id: data.id }, { 'reload': true })
            }
        })
    }

    resetPassword () {
        if (!this.formdata.id) {
            //user does not exists yet, this shouldnt happen
            return
        }
        this.$http.post('/user/resetpassword', { email: this.formdata.email }).then((response) => {
            if (response.status === 200) {

                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.error_message?error=password_reset', //@todo is eigenlijk geen error, misbruik van bestaande toast
                    hideDelay: 6000,
                    position: ('top right')
                })

            }
        })
    }

    checkEmail () {
        let email = this.formdata.email
        this.$http.post('/checkmail', { email: email }).then((data) => {
            this.emailExists = !!data.data.email
        })
    }

    invite ($event) {
        let email = this.formdata.email

        this.$mdDialog.show({
            controller: 'InviteUserDialogCtrl',
            templateUrl: 'inviteUserDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: $event,
            clickOutsideToClose: true,
            locals: { email: email }
        })
    }
}

UserFormCtrl.$inject = ['$state', '$stateParams', 'User', '$mdToast', '$http', '$mdDialog', '$rootScope']

module.exports = UserFormCtrl
